export type ExperienceRating =
  | "not-selected"
  | "pouting"
  | "frown"
  | "meh"
  | "smile"
  | "grin"

export enum ExperienceRatingWeights {
  "not-selected" = 0,
  "pouting" = 1,
  "frown" = 2,
  "meh" = 3,
  "smile" = 4,
  "grin" = 5
}
